/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetLatestChatFilesRequest,
  TGetLatestChatFilesModel,
  IMappers,
  TGetLatestChatFilesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IChatFilesResponse } from '../../entities/file/ChatFilesResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetLatestChatFilesModel(parameters: IGetLatestChatFilesRequest): TGetLatestChatFilesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'chats',
    pathApi: '/v1/get-latest-chat-files/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetLatestChatFilesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetLatestChatFilesRequest;
}

export async function fetchGetLatestChatFiles<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetLatestChatFilesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetLatestChatFilesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetLatestChatFilesModel(parameters),
    config,
  )) as FetchResponse<TGetLatestChatFilesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatFilesResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetLatestChatFilesResponse>;
}
